import React from 'react'
import './Footer.css'
import footerarc from './Assets/Ellipse 4.png'
import footerarcmob from './Assets/Ellipse 0.png'
import logo from './Assets/Group 1171275328.png'

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-arc">
                <img src={footerarc} alt="footer arc" />
            </div>

            <div className="footer-arcmob">
                <img src={footerarcmob} alt="footer arc" />
            </div>
            <div className="footer-content">
                <div className="footer-top">
                    <span className='footer-heading'>Technology</span>
                    <span className='footer-dot'>•</span>
                    <span className='footer-heading'>Creativity</span>
                    <span className='footer-dot'>•</span>
                    <span className='footer-heading'>Impact</span>
                </div>

                <div className="footer-logo">
                    <img src={logo} alt="Kushmanda logo" />
                    <p className="footer-description">
                        Crafting products that are useful and aesthetic
                    </p>
                </div>

                <div className="footer-bottom">
                    <p>© 2025 Kushmanda.ai. All rights reserved.</p>

                    <p>
                        Contact Us &nbsp;
                        <a href="mailto:contact@kushmanda.tech">contact@kushmanda.ai</a>
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default Footer
